<template>
<div>
  <div class="title-top-alarm">
    <div>
      <span>{{groupMsgObj.openTitle}}</span>
    </div>
    <div class="line-title"></div>
  </div>
  <el-form style="margin: 10px 50px 0" :model="groupMsgForm" :rules="groupMsgRules" ref="groupMsgForm" label-width="80px" class="demo-ruleForm">
    <el-form-item label="群聊名称" prop="name">
      <el-input v-model="groupMsgForm.name" placeholder="请输入群聊名称"></el-input>
    </el-form-item>
  </el-form>
  <div style="margin-top: 15px">
    <el-row style="margin: 0 30px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeAddEdit()">
          <span>取消</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn" @click="submitAddEdit('groupMsgForm')">
          <span>确定</span>
        </div>
      </el-col>
    </el-row>
  </div>
  <div style="height: 20px"></div>
</div>
</template>

<script>
import {addmsggroup, updatemsggroup} from '../../../api/device'

export default {
  name: 'addEditGroupMsg',
  model: {
    prop: 'addGroupMsgShow',
    event: 'change'
  },
  props: {
    groupMsgObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      groupMsgForm: {
        name: ''
      },
      groupMsgRules: {
        name: [
          { required: true, message: '请输入群聊名称', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    if (!this.groupMsgObj.isAdd) {
      this.groupMsgForm.name = this.groupMsgObj.groupMsgRow.name
    }
  },
  methods: {
    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.groupMsgObj.isAdd) {
            let data = {
              orgid: this.$store.state.user.orgid,
              name: this.groupMsgForm.name
            }
            addmsggroup(data).then(res => {
              this.$notify({
                title: '成功',
                message: '成功新建群聊',
                type: 'success',
                duration: 2000
              })
              this.$emit('change', false)
              this.$emit('getFamilyGroup', {id: res.data.msggroupid})
            }).catch(() => {
              this.$notify.error({
                title: '失败',
                message: '新建群聊失败'
              })
            })
          } else {
            let data = {
              msggroupid: this.groupMsgObj.groupMsgRow.id,
              name: this.groupMsgForm.name
            }
            updatemsggroup(data).then(res => {
              this.$notify({
                title: '成功',
                message: '成功修改群聊',
                type: 'success',
                duration: 2000
              })
              this.$emit('change', false)
              this.$emit('getFamilyGroup', {id: this.groupMsgObj.groupMsgRow.id})
            }).catch(() => {
              this.$notify.error({
                title: '失败',
                message: '修改群聊失败'
              })
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/deviceComponents/addEditGroupMsg.vue